import { render } from "./BloqueosPage.vue?vue&type=template&id=2184a9b8"
import script from "./BloqueosPage.vue?vue&type=script&lang=js"
export * from "./BloqueosPage.vue?vue&type=script&lang=js"

import "./BloqueosPage.vue?vue&type=style&index=0&id=2184a9b8&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__